import { DataUtilities } from "../../../../Common/DataUtilities";
import { IDesignValidationProvider, ValidationIssue } from "../../../../Common/IDesignValidationProvider";
import { IDataDefinition } from "../../../../Common/Data/Definitions/IDataDefinition";
import { IConfigStorage } from "../../../../Common/IConfigStorage";
import { StringDataDefinition } from "../../../../Common/Data/Definitions/StringDataDefinition";
import { ExpressionConfiguration } from "../../../../Expressions/ExpressionConfiguration";
import { ObjectDataDefinition } from "../../../../Common/Data/Definitions/ObjectDataDefinition";
import { ExpressionValueType } from "../../../../Expressions/ExpressionValueType";
import { BooleanDataDefinition } from "../../../../Common/Data/Definitions/BooleanDataDefinition";
import { DataDefinitionUtilities } from "../../../../Common/DataDefinitionUtilities";

export class ValueRuleColumn implements IConfigStorage, IDesignValidationProvider {
    _id: string = DataUtilities.generateUniqueId();
    columnName?: string;

    cellData: IDataDefinition = new StringDataDefinition("cellValue");
    expression: ExpressionConfiguration;

    constructor(columnName?: string) {
        this.columnName = columnName;
        this.expression = new ExpressionConfiguration();
        this.expression.valueType = ExpressionValueType.SUBEXPRESSION;
        let executionDef = new BooleanDataDefinition(this.columnName || "");
        this.expression.executionResult = () => executionDef;
    }

    getDesignValidationIssues(): ValidationIssue[] {
        let issues: ValidationIssue[] = [];

        if (this.cellData instanceof ObjectDataDefinition) {
            if (this.cellData.fields.length === 0) {
                issues.push(new ValidationIssue("Object data not setup. Object must contain fields."));
            }
        }

        return [...issues, ...this.expression.getDesignValidationIssues()];
    }

    getStorageData(): object {
        let data = {};

        Reflect.set(data, "_id", this._id);
        Reflect.set(data, "columnName", this.columnName);
        Reflect.set(data, "cellData", this.cellData.getStorageData());
        Reflect.set(data, "expression", this.expression.getStorageData());

        return data;
    }

    setStorageData(data: object): void {
        this._id = Reflect.get(data, "_id");
        this.columnName = Reflect.get(data, "columnName");
        let ex = new ExpressionConfiguration();
        ex.setStorageData(Reflect.get(data, "expression"));
        this.expression = ex;

        this.cellData = DataDefinitionUtilities.getDataDefinitionFromData(Reflect.get(data, "cellData"))!;
    }
}
